import React, { useEffect, useState } from "react";

const PublicFeeStructure = () => {
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  //   const [error, setError] = useState("");

  // useEffect(() => {
  //   return async () => {
  //     try {
  //       const automationResponse = await fetch(
  //         "https://api.mirai.healthcare/api/head/school-rule/school-automation",
  //         {
  //           headers: {
  //             accept: "application/json",

  //             // schoolid: currentSchoolId,
  //           },
  //         }
  //       );
  //       if (automationResponse.ok) {
  //         const automationData = await automationResponse.json();
  //         if (Array.isArray(automationData) && automationData?.length) {
  //           setImageUrl(automationData[0]?.feeStructure);
  //           setLoading(false)
  //           //   setSchoolLogoDataUrl(await fetchImageAsDataURL(automationData[0]?.schoolLogo));
  //         } else if (automationData && typeof automationData === "object") {
  //           setImageUrl(automationData.feeStructure);
  //           setLoading(false)
  //           //setSchoolLogoDataUrl(await fetchImageAsDataURL(automationData.schoolLogo));
  //         } else {
  //           setImageUrl(null);
  //           setLoading(false)
  //         }
  //       } else {
  //         console.warn(
  //           "School automation API failed with status",
  //           automationResponse.status
  //         );
  //         setImageUrl(null);
  //         setLoading(false)
  //       }
  //     } catch (automationError) {
  //       console.error("School automation fetch error:", automationError);
  //       setImageUrl(null);
  //       setLoading(false)
  //     }
  //   }
  //   // Example API endpoint (you can replace this with your own)


  // }, []);

  useEffect(() => {
  const fetchData = async () => {
    try {
      const automationResponse = await fetch(
        "https://api.mirai.healthcare/api/head/school-rule/school-automation",
        {
          headers: {
            accept: "application/json",
          },
        }
      );

      if (automationResponse.ok) {
        const automationData = await automationResponse.json();

        if (Array.isArray(automationData) && automationData.length) {
          setImageUrl(automationData[0]?.feeStructure);
        } else if (automationData && typeof automationData === "object") {
          setImageUrl(automationData.feeStructure);
        } else {
          setImageUrl(null);
        }
      } else {
        setImageUrl(null);
      }
    } catch (error) {
      console.error("API error:", error);
      setImageUrl(null);
    } finally {
      setLoading(false); // ✅ always stop loading
    }
  };

  fetchData(); // ✅ IMPORTANT
}, []);


  if (loading) return <p>Loading...</p>;


  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h2>Fee Structure</h2>
      <img
        src={imageUrl}
        alt="Error Loading Structure, Please contact to School."
        style={{ width: "auto", height: "auto", borderRadius: "8px" }}
      />

    </div>
  );
};

export default PublicFeeStructure;
